export * from '@novel-segment/loaders';
import { requireDefault, requireModule } from '@novel-segment/loaders';

export { requireDefault, requireModule }

export default requireDefault
